RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _) {

    'use strict';

    selectors.Layout = RivalIQ.views.Select.extend({
        name: 'layout',

        onChange: function (layout) {
            const me = this;

            me.dashboardModel.setProps({
                layout: layout
            });
        },

        getLayouts: function () {
            const Types = RivalIQ.views.SocialPostGrid.types;
            return [
                {
                    id: undefined,
                    name: 'List'
                },
                {
                    id: Types.grid,
                    name: 'Grid'
                },
                {
                    id: Types.gridWithDetails,
                    name: 'Grid with Details'
                },
                {
                    id: Types.mosaic,
                    name: 'Mosaic'
                },
                {
                    id: Types.mosaicWithDetails,
                    name: 'Mosaic with Details'
                }
            ];
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);

            me.selected = me.dashboardModel.getProp('layout');
            me.items = me.getLayouts();
        }
    });

});
